var saveForLaterModal = $('[data-modal-id="save-for-later-popup"]');
var saveForLaterForm = $('#save-for-later-form');
var successElement = $('#save-for-later-success');
var errorElement = $('#save-for-later-error');
var defaultElement = $('#save-for-later-default');
var formInputs = $('#save-for-later-form :input');
var submitButton = $('#save-for-later-form button[type="submit"]');
var emailField = $('#save-for-later-form input[name="email"]');
var smsField = $('#save-for-later-form input[name="sms"]');
var sendEmailCheckbox = $('#save-for-later-form input[name="send-email"]');
var sendSmsCheckbox = $('#save-for-later-form input[name="send-sms"]');

function resetFormFields() {
    submitButton.button('reset');
    formInputs.prop('disabled', false);
    sendEmailCheckbox.prop('checked', false);
    sendSmsCheckbox.prop('checked', false);
    emailField.prop('required', emailField.val() !== '');
    smsField.prop('required', smsField.val() !== '');
    submitButton.prop('disabled', !emailField.val() && !smsField.val());
}
function resetFormDisplay() {
    errorElement.hide();
    successElement.hide();
    defaultElement.show();
}
function resetBoth() {
    resetFormFields();
    resetFormDisplay();
}

var modalDelayEnabled = null;
var defaultModalDelay = 20;
var modalDelay = null;

function getSaveForLaterStorage() {
    var saveForLater = JSON.parse(localStorage.getItem('save_for_later'));

    if (saveForLater) {
        var currentDate = new Date(),
            expirationDate = saveForLater.expiresAt;

        if (Date.parse(currentDate) < Date.parse(expirationDate)) {
            return saveForLater.modalDisplayed;
        }
        localStorage.removeItem('save_for_later');
    }

    return null;
}

function setSaveForLaterStorage() {
    var expiry = new Date();
    expiry.setHours(expiry.getHours() + 1);
    localStorage.setItem('save_for_later', JSON.stringify({
        expiresAt: expiry,
        modalDisplayed: true
    }));
}

var modalShown = false;
saveForLaterModal.on('shown.bs.modal', function() {
    setSaveForLaterStorage();
    modalShown = true;
});

$.ajax({
    type: 'GET',
    url: '/save-for-later/config',
}).done(function(data) {
    modalDelayEnabled = (data.modal_delay_enabled ? data.modal_delay_enabled : true);
    modalDelay = (data.modal_delay ? data.modal_delay : defaultModalDelay);
}).fail(function() {
    modalDelayEnabled = true;
    modalDelay = defaultModalDelay;
}).always(function() {
    if (modalDelayEnabled) {
        if (getSaveForLaterStorage() === null) {
            setTimeout(function() {
                if (modalShown === false) {
                    modalShown = true;
                    saveForLaterModal.modal('show');
                    setSaveForLaterStorage();
                }
            }, modalDelay * 1000);
        }
    }
});

$('body').on('submit', '#save-for-later-form', function(e) {
    e.preventDefault();
    errorElement.hide();
    successElement.hide();
    submitButton.button('loading');
    var formData = saveForLaterForm.serialize();
    formInputs.prop('disabled', true);

    $.ajax({
        type: saveForLaterForm.attr('method'),
        url: saveForLaterForm.attr('action'),
        data: formData
    }).done(function() {
        defaultElement.hide();
        successElement.show();
        setTimeout(function() {
            saveForLaterModal.modal('hide');
            saveForLaterForm.trigger('reset');
        }, 2000);
    }).fail(function() {
        errorElement.show();
        resetFormFields();
    });
});

formInputs.on('change keypress', function() {
    submitButton.prop('disabled', !emailField.val() && !smsField.val());
});

emailField.on('change keypress', function() {
    sendEmailCheckbox.prop('checked', true).change();
    sendEmailCheckbox.parent().toggleClass('checked', !submitButton.prop('disabled'));
});

smsField.on('change keypress', function() {
    sendSmsCheckbox.prop('checked', true).change();
});

sendEmailCheckbox.on('change', function() {
    if (!this.checked) {
        emailField.val('');
    }
    emailField.prop('required', this.checked);
});

sendSmsCheckbox.on('change', function() {
    if (!this.checked) {
        smsField.val('');
    }
    smsField.prop('required', this.checked);
});

saveForLaterModal.on('hidden.bs.modal', function() {
    resetBoth();
});

saveForLaterModal.on('shown.bs.modal', function() {
    submitButton.prop('disabled', !emailField.val() && !smsField.val());
});
